module.exports = __webpack_public_path__ + "static/media/bmi.85e435f6.gif";